import React from 'react';
import { CheckIcon, CircleDashedIcon } from 'lucide-react';
import { Band } from './Band';
import { evidenceEstablished, evidenceInProgress } from '../../data/site';
export function Evidence() {
  return <Band id="evidence" eyebrow="Evidence and status" title="What we've proven, and what we haven't." description="Lentic is early. Stating exactly where the evidence stops is part of the product argument, not a caveat attached to it." data-id="element-148" data-mp="3cbqzxjk6eufu">
      <div className="grid gap-4 lg:grid-cols-2" data-id="element-149" data-mp="3lcf2ni44d8df">
        <section className="rounded-2xl border border-teal/30 bg-teal/[0.05] p-8 lg:p-10" data-id="element-150" data-mp="3qb8gxcr8d3en">
          <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-teal" data-id="element-151" data-mp="3v2qk87gq7g2s">
            Established
          </h3>
          <ul className="mt-7 space-y-5" data-id="element-152" data-mp="3wgr7sls6qz3">
            {evidenceEstablished.map(item => <li key={item} className="flex items-start gap-3" data-id="element-153" data-mp="7y2ca18gybkd">
                <CheckIcon className="mt-1.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-154" data-mp="7vpjet16agsj" />
                <span className="max-w-[52ch] text-lg leading-relaxed text-ink" data-id="element-155" data-mp="cx542jzfulae">
                  {item}
                </span>
              </li>)}
          </ul>
        </section>

        <section className="rounded-2xl border border-mist bg-white/60 p-8 lg:p-10" data-id="element-156" data-mp="24r8ugbopvh4d">
          <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-graphite" data-id="element-157" data-mp="1zu08e00g6sxu">
            In progress
          </h3>
          <ul className="mt-7 space-y-5" data-id="element-158" data-mp="1uvfa464rajc1">
            {evidenceInProgress.map(item => <li key={item} className="flex items-start gap-3" data-id="element-159" data-mp="2sgkzr0gxb51e">
                <CircleDashedIcon className="mt-1.5 h-4 w-4 shrink-0 text-muted" aria-hidden="true" data-id="element-160" data-mp="2niruqarcwh2p" />
                <span className="max-w-[52ch] text-lg leading-relaxed text-graphite" data-id="element-161" data-mp="2irjm3gxuozql">
                  {item}
                </span>
              </li>)}
          </ul>
        </section>
      </div>

      <p className="mt-10 max-w-[70ch] font-display text-2xl font-light leading-snug text-ink" data-id="element-162" data-mp="3b7u999qp1tsz">
        We publish the analysis plan before we run it, and we report the cases
        where the assessment failed to discriminate. A company whose premise is
        that people should verify before they accept can't afford to overstate
        its own results.
      </p>
    </Band>;
}